import React, {useEffect, useRef, useState} from 'react';
import {Image, Label, Layer, Stage, Text} from 'react-konva';
import { jsPDF } from "jspdf";
import "../templates/fonts.css"
import Engagement from "../templates/Engagement-Regular.ttf";
import Caveat from "../templates/Caveat-VariableFont_wght.ttf";
import DancingScript from "../templates/DancingScript-VariableFont_wght.ttf";
import BookAntiqua from "../templates/Book-Antiqua.ttf";
import Calibri from "../templates/calibri.ttf";
import Times from "../templates/times.ttf";
import 'jspdf-autotable';

const CertificateViewer = ({id, labels, texts, images,qrCode, data, backgroundImageUrl, qr}) => {

    const [backgroundImage, setBackgroundImage] = useState(null);
    const [qrImage, setQRImage] = useState(null);
    const [imageMaps, setImageMaps] = useState(null);
    const [qrUrl, setQrUrl] = useState(null);

    const handImageLoad = (e) => {
        setBackgroundImage(e.target)
    }
    const handQRImageLoad = (e) => {
        setQRImage(e.target)
    }

    const stageRef = useRef();

    const getBase64 = async(file) =>{
        try {
            const response = await fetch(file);
            const blob = await response.blob();
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            return new Promise((resolve, reject) => {
                reader.onloadend = () => {
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };
                reader.onerror = reject;
            });
        } catch (error) {
            console.error('Error fetching font:', error);
            throw error;
        }
    }

    const addFont = async(pdf) =>{
        let base64 = await getBase64(Engagement);
        pdf.addFileToVFS('./fonts/Engagement-Regular.ttf', atob(base64));
        pdf.addFont("./fonts/Engagement-Regular.ttf","Engagement","normal");

        let base6 = await getBase64(Caveat);
        pdf.addFileToVFS('./fonts/Caveat-Regular.ttf', atob(base6));
        pdf.addFont("./fonts/Caveat-Regular.ttf","Caveat","normal");

        let base = await getBase64(DancingScript);
        pdf.addFileToVFS('./fonts/DancingScript-Regular.ttf', atob(base));
        pdf.addFont("./fonts/DancingScript-Regular.ttf","DancingScript","normal");

        let bas = await getBase64(BookAntiqua);
        pdf.addFileToVFS('./fonts/Book-Antiqua.ttf', atob(bas));
        pdf.addFont("./fonts/Book-Antiqua.ttf","BookAntiqua","normal");

        let ba = await getBase64(Calibri);
        pdf.addFileToVFS('./fonts/calibri.ttf', atob(ba));
        pdf.addFont("./fonts/calibri.ttf","Calibri","normal");

        let b = await getBase64(Times);
        pdf.addFileToVFS('./fonts/times.ttf', atob(b));
        pdf.addFont("./fonts/times.ttf","Times","normal");
    }


    const onDownload = async()=>{
        var pdf = new jsPDF('l','px',[500,800]);
        await addFont(pdf);
        backgroundImageUrl = backgroundImageUrl.replace("itmatic.io","codebrigade.in");
        pdf?.addImage(backgroundImageUrl,'JPEG',0,0,800,500, '','FAST');

        images?.map((text, index) => {
            let y = text?.y
            if(text?.y >= 300){
                y = text?.y*0.264583+(text?.y-20);
            }
            else{
                y = text?.y*0.264583+(text?.y-20);
            }
            imageMaps[index] = imageMaps[index]?.src?.replace("itmatic.io","codebrigade.in");
            pdf?.addImage(imageMaps[index],'JPEG',
            text?.x*1.27,
            y,
            text?.width,text?.height, '','FAST'); 
        });

        if(qrUrl !== null){
            let x = !qrCode?.x ? 0 : qrCode?.x*1.228;
            let y = !qrCode?.y ? 0 : qrCode?.y*1.12;
            pdf?.addImage(qrUrl,'JPEG',x,y,60,60); 
        }

        labels?.map((text) => {           
            const size = text.fontSize / 0.75; // convert pixels to points
            pdf?.setFontSize(size);
            pdf.setTextColor(text.color);
            pdf.setFont(text.fontFamily);
            if(text?.align === "center"){
            let x = ((text.x*1.25)+(text.width/1.7));
            if(data[text.text]){
                pdf?.text(data[text.text], x, text?.y*1.11,{
                    baseline:'top',
                    color: text?.color,
                    fontFamily: text.fontFamily,
                    maxWidth: text?.width,
                    align:'center',
                });
            }    
        } 
        else{
            let x = text?.x*1.25;
            pdf?.setFontSize(size);
            pdf?.setTextColor(text?.color);
            pdf.setFont(text.fontFamily);
            if(data[text.text]){
                pdf?.text(data[text.text], x, text?.y*1.11,{
                    baseline:'top',
                    color: text?.color,
                    fontFamily: text.fontFamily,
                    maxWidth: text?.width,
                    align:'left'
                }); 
            }      
        } 
        }); 

        texts?.map((text) => {
            console.log(text.text);           
            const size = text.fontSize / 0.75; // convert pixels to points
            pdf?.setFontSize(size);
            pdf.setTextColor(text.color);
            pdf.setFont(text.fontFamily);
            if(text?.align === "center"){
            let x = ((text.x*1.25)+(text.width/1.7));
            if(text?.text){
                pdf?.text(text.text, x, text?.y*1.11,{
                    baseline:'top',
                    color: text?.color,
                    fontFamily: text.fontFamily,
                    maxWidth: text?.width,
                    align:'center',
                });
            }    
        } 
        else{
            let x = text?.x*1.25;
            pdf?.setFontSize(size);
            pdf?.setTextColor(text?.color);
            pdf.setFont(text.fontFamily);
            if(text?.text){
                pdf?.text(text.text, x, text?.y*1.11,{
                    baseline:'top',
                    color: text?.color,
                    fontFamily: text.fontFamily,
                    maxWidth: text?.width,
                    align:'left'
                }); 
            }      
        } 
        });
        pdf.save(`${data?.name || data?.Name || data[Object.keys(data)[1]] }.pdf`);
    }

    useEffect(()=>{

        if(id !== 'new')
        {
            setQrUrl('https://api.qrserver.com/v1/create-qr-code/?size=50x50&data=https://events.chitkara.edu.in/certificate/'+id);
        
            if(backgroundImage && imageMaps 
                && !window.location.href.includes('certificates')
                && window.location.href.includes('certificate')){
            }
        }
    },[id, imageMaps, backgroundImage])

    // function downloadURI(uri, name) {
    //     var link = document.createElement('a');
    //     link.download = name;
    //     link.href = uri;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    // }

    useEffect(() => {
        if (qrUrl) {
            if(qrUrl.includes("itmatic")){
                qrUrl = qrUrl.replace("itmatic.io","codebrigade.in");
            }
            const image = new window.Image();
            image.crossOrigin = 'Anonymous';

            image.src = qrUrl;
            image.addEventListener('load', handQRImageLoad);
            return () => {
                image.removeEventListener('load', handQRImageLoad)
            };
        }
    }, [qrUrl]);

    useEffect(() => {
        if (backgroundImageUrl) {
        
            backgroundImageUrl = backgroundImageUrl.replace("itmatic.io","codebrigade.in");
            const image = new window.Image();
            image.crossOrigin = 'Anonymous';

            image.src = backgroundImageUrl;
            image.addEventListener('load', handImageLoad);
            return () => {
                image.removeEventListener('load', handImageLoad)
            };
        }
    }, [backgroundImageUrl]);

    useEffect(() => {
        images.forEach(({url}, index) => {
            url = url.replace("itmatic.io","codebrigade.in");
            const image = new window.Image();
            image.crossOrigin = 'Anonymous';
            
            image.src = url;
            image.addEventListener('load', (e) => {
                setImageMaps(i => ({...i, [index]: e.target}))
            });
        })

    }, [images]);
 
    return (
        <>
            {/* <div style={{visibility:"hidden"}}>
            <p style={{ color:"#DF0101", fontFamily:"DancingScript" }} >DancingScript</p>
            <p style={{ color:"#DF0101", fontFamily:"Engagement" }} >Engagement</p>
            <p style={{ color:"#DF0101", fontFamily:"Caveat" }} >Caveat</p>
            </div> */}
            <Stage width={650} height={450} ref={stageRef}>
                <Layer>
                    <Image image={backgroundImage} width={650} height={450}/>
                </Layer>
                {qr &&
                <Layer>
                    <Image image={qrImage}  width={70} 
                    height={70} x={qrCode?.x} y={qrCode?.y}/>
                </Layer>
                }
                              
                {images?.map((star, index) => ( 
                <Layer key={star.key}>
                        {imageMaps && <Image
                            id={star.id}
                            x={star.x}
                            y={star.y}
                            width={star.width}
                            height={star.height}
                            image={imageMaps[index]}
                        />}
                </Layer>
                ))}
                {labels?.map((star, index) => (
                <Layer>
                        <Label
                            id={star.id}
                            key={star.key}
                            x={star.x}
                            y={star.y}
                            width={star?.width}
                            opacity={1}
                            rotation={star.rotation}
                        >
                        <Text width={star?.width}  align={star?.align} text={data[star.text] || star.text} 
                        fontSize={star.fontSize} fontFamily={star.fontFamily || "Arial"} fill={star.color}/>
                        </Label>
                </Layer> 
                ))}
                {texts?.map((star, index) => (
                <Layer>
                        <Label
                            id={star.id}
                            key={star.key}
                            x={star.x}
                            y={star.y}
                            width={star?.width}
                            opacity={1}
                            rotation={star.rotation}
                        >
                        <Text width={star?.width} align={star?.align} text={data[star.text] || star.text} 
                        fontSize={star.fontSize} fontFamily={star.fontFamily || "Arial"} fill={star.color}/>
                        </Label>
                </Layer> 
                ))}
            </Stage>
            <div className='download-button' style={{cursor: 'pointer'}} onClick={onDownload}>{!backgroundImage ? 'Please Wait' : 'Download'}</div>
        </>
    );
};
export default CertificateViewer;
